import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ErrorBoundary, { isChunkError, reloadOnceForChunkError } from "@/components/ErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// After a deploy the previous build's chunks are gone; a lazy import that fails
// surfaces as an unhandled rejection before any boundary sees it. Reload once
// into the fresh build. The guard is cleared shortly after a successful boot.
window.addEventListener("unhandledrejection", (e) => {
  if (isChunkError(e && e.reason)) reloadOnceForChunkError();
});
try { setTimeout(() => sessionStorage.removeItem("vtx-chunk-reload"), 5000); } catch { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
